import buildInstitutionURL from '$utils/buildInstitutionURL';

/**
 *
 * @param {string} spaceId
 * @param {string} id The assignment id
 * @param {Boolean} isEducator
 * @param {Object[]} submission The student submission
 * @returns URL to the appropriate Quiz page in the Aula web app
 */
const buildQuizURL = ({ spaceId, submission, id, isEducator }) => {
  if (isEducator) {
    const pathToSubmissions = `#/dashboard/${spaceId}/journey/assignments/${id}/submissions`;
    return buildInstitutionURL({ subdomain: null, path: pathToSubmissions });
  }

  const hasSubmission = submission && !!submission.length;

  if (hasSubmission) {
    const submissionId = submission[0].objectId;
    const pathToSubmissionReport = `#/dashboard/${spaceId}/journey/reports/${id}/${submissionId}/feedback`;
    return buildInstitutionURL({
      subdomain: null,
      path: pathToSubmissionReport,
    });
  }

  const pathToQuizPage = `#/dashboard/${spaceId}/journey/quizzes/${id}`;
  return buildInstitutionURL({ subdomain: null, path: pathToQuizPage });
};

export default buildQuizURL;
